import React from 'react';

export default function Bill() {
  return <div>Bill</div>;
}
